import React, { Suspense } from 'react'

const SuspenseWrapperIndex = ({ path }) => {
    const LazyComponent = React.lazy(() => import(`../../components/${path}`))

    return (
        <Suspense fallback={null} >
            <LazyComponent /> 
        </Suspense>
    )
}

export default SuspenseWrapperIndex

/*
import { PiSpinnerLight } from "react-icons/pi"
<PiSpinnerLight size={50} color="#6366f1" className="animate-spin" sx={{ opacity: 0}} />
*/